import {useTranslation} from 'react-i18next';


const Translator = (props) => {
    const { file, name, variables, isHtml } = props;
    const { t } = useTranslation(file);

    return isHtml
        ? <span dangerouslySetInnerHTML={{__html: t(name, variables)}} />
        : t(name, variables);
}

export default Translator;
